import gql from 'graphql-tag';

export const CREATE_EXAM = gql`
  mutation CreateExam($input: ExamInput!) {
    createExam(input: $input) {
      _id
    }
  }
`;
